// getApiUrl
function getApiUrl(url) {
    return `${url}`;
}

// checkStatus
function checkStatus(response) {
    if (response.status >= 200 && response.status < 300) {
        return response.json();
    }
}

export default function request(url, { ...options }) {
    return fetch(getApiUrl(url), { ...options }).then(checkStatus);
}
